import moment from "moment";
import { routes } from "../../constants/api-routes";
import { networkService } from "../../networking/network-services";
import { methods } from "../../utils/methods";
import showToast from "../../utils/toast";
import axios from "axios";

export const timeToSeconds = (timeStr: string): number => {
  const time = moment(timeStr, 'YYYY-MM-DD HH:mm:ss');
  const seconds = time.hours() * 3600 + time.minutes() * 60;
  return seconds >= 0 && seconds < 86400 ? seconds : 0;
};

export const getAddressFromLatLong = async (latitude: any, longitude: any) => {
  try {
    const response = await axios.get(
      `https://maps.googleapis.com/maps/api/geocode/json`,
      {
        params: {
          latlng: `${latitude},${longitude}`,
          key: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
        },
      }
    );
    if (response.data.status === "OK" && response.data.results.length > 0) {
      return response.data.results[0].formatted_address; // Return the formatted address
    } else {
      throw new Error("Address not found");
    }
  } catch (error) {
    console.error("Error fetching address:", error);
  }
};

export const getDeviceDetails = async (deviceId: any) => {
  try {
    const { status, data } = await networkService.request({
      method: methods.get,
      url: routes.services.getDeviceDetails,
      params: { deviceId },
    });

    if (status === 200) {
      const device = data.response.data;
      const lastLocation = data.response.last_location;
      const imageData = {
        front: data.response.data.front_img,
        rear: data.response.data.rear_img,
      };
      const formattedDeviceDetails = {
        "Device Name": device.device_name || "Not Found",
        IMEI: device.device_imei || "Not Found",
        Model: device.device_model || "Not Found",
        Company: device.device_company_name || "Not Found",
        Description: device.device_description || "Not Found",
        Fleet: device.fleet_id || "Not Found",
        "Installation Date": device.device_installation_date
          ? moment(device.device_installation_date).format("lll")
          : "Not Found",
        "Activation Date": device.device_activation_date
          ? moment(device.device_activation_date).format("lll")
          : "Not Found",
        "Deactivation Date": device.device_deactivation_date
          ? moment(device.device_deactivation_date).format("lll")
          : "Not Found",
      };

      return { formattedDeviceDetails, lastLocation, imageData };
    } else {
      showToast("Failed to Fetch Device Details", "e");
      return false;
    }
  } catch (error) {
    showToast("Failed to Fetch Device Details", "e");
    return false;
  }
};

// Calendar dates from the server (days with recording slots or AI events), so
// the calendar works while the device is offline. Same {dates: [...]} shape as
// the device's /get-dates.
export const getDeviceAvailableDates = async (uuid: any) => {
  try {
    if (!uuid) return false;
    const { status, data } = await networkService.request({
      method: methods.get,
      url: `api/devices/${uuid}/available-dates/`,
      params: { days: 120 },
    });
    if (status === 200) {
      return data;
    }
  } catch (error) {
    return false;
  }
};

export const deleteDeviceLine = async (tunnelUrl: any, name: any, type: any) => {
  try {
    const { data, status } = await axios.delete(`${String(tunnelUrl).replace(/\/+$/, "")}/` + routes.services.deleteDeviceLineByName(name, type),
      {
        headers: {
          Accept: "application/json",
        },
      }
    );
    if (status === 200) {
      showToast("Line/Zone Deleted Successfully", "s");
      return data;
    }
  } catch (error) {
    console.error("getAllDevicesData error:", error);
    return false;
  }
};

export const editLineZoneWise = async (tunnelUrl: any, oldName: string, newName: string) => {
  try {
    const { data, status } = await axios.post(tunnelUrl + routes.services.editLineZone,
      {
        old_name: oldName,
        new_name: newName,
      }
    );
    if (status === 200) {
      showToast("Line renamed successfully", "s");
      return data;
    }
  } catch (error: any) {
    console.error("getAllDevicesData error:", error);
    showToast(error.message || "Failed to Rename Line", "e");
    return false;
  }
};

// export const getVideoListData = async (selectedDate: any, uuid: any,tunnelUrl:any) => {
//   try {
//     const { status, data } = await networkService.request({
//       method: methods.get,
//       url: routes.services.getVideoListDemo(selectedDate, uuid,tunnelUrl),
//     });
//     if (status === 200 && Array.isArray(data)) {
//       const groupedByCamera = data.reduce((acc: any, video: any) => {
//         const referenceDay = moment(video.start_time, "HH:mm:ss").startOf("day");
//         const formattedVideo = {
//           start_time: video.start_time,
//           end_time: video.end_time,
//           specific_file_url: video.specific_file_url,
//           sloat: video.slot,
//           start: moment(video.start_time, "HH:mm:ss").diff(referenceDay, "seconds"),
//           end: moment(video.end_time, "HH:mm:ss").diff(referenceDay, "seconds"),
//         };
//         if (!acc[video.camera]) {
//           acc[video.camera] = [];
//         }
//         acc[video.camera].push(formattedVideo);
//         return acc;
//       }, {});
//       return Object.values(groupedByCamera);
//     }
//     return [];
//   }
//   catch (error) {
//     showToast(
//       "No Video Found on this Trip. Please Select Another Trip.",
//       "e"
//     );
//     return [];
//   }
// };

export const getVideoListData = async (
  selectedDate: any,
  uuid: any,
  tunnelUrl: any
) => {
  try {
    const { status, data } = await networkService.request({
      method: methods.get,
      url: routes.services.getVideoListDemo(
        selectedDate,
        uuid,
        tunnelUrl
      ),
    });
    if (status === 200 && data?.slots?.length) {
      const referenceDay = moment("00:00:00", "HH:mm:ss").startOf("day");
      const formattedVideos = data.slots.map((video: any) => ({
        start_time: video.start_time,
        end_time: video.end_time,
        specific_file_url: `${data.base_url}${video.path}`,
        slot: video.slot,
        start: moment(video.start_time, "HH:mm:ss").diff(
          referenceDay,
          "seconds"
        ),
        end: moment(video.end_time, "HH:mm:ss").diff(
          referenceDay,
          "seconds"
        ),
      }));
      return [formattedVideos];
    }
    return [];
  } catch (error) {
    showToast(
      "No Video Found on this Trip. Please Select Another Trip.",
      "e"
    );
    return [];
  }
};

export const getAlarmAddressDetails = async (e: any) => {
  try {
    const { data, status } = await networkService.request({
      url: `${routes.services.getAlarmAddress(e)}`,
      method: methods.get,
    });
    if (status === 200) {
      return data;
    }
  } catch (error) {
    return false;
  }
};

export const getAllDevicesData = async (token: any) => {
  try {
    const { data, status } = await axios.get(
      process.env.REACT_APP_UAT_URL + routes.services.allDevicesList,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      }
    );

    if (status === 200) {
      return data;
    }
  } catch (error) {
    console.error("getAllDevicesData error:", error);
    return false;
  }
};

// Graph data comes from the server, not the device tunnel, so it shows even
// while the device is offline. The server counts DISTINCT events, which drops
// the re-sent upload batches that used to make the platform ~10% high; the
// shapes are the device's own /ai-series and /ai-region-counts.
export const getDeviceAiRegionCounts = async ({ statDate, endDate, uid }: any) => {
  try {
    if (!uid) return false;
    const { data, status } = await networkService.request({
      method: "GET",
      url: `api/devices/${uid}/ai-region-counts/`,
      params: { start_datetime: statDate, end_datetime: endDate },
    });
    if (status === 200) {
      return data;
    }
  } catch (error) {
    console.error("getDeviceAiRegionCounts error:", error);
    return false;
  }
};

export const getDeviceAiSeries = async ({ statDate, endDate, region, uid }: any) => {
  try {
    if (!uid) return false;
    const { data, status } = await networkService.request({
      method: "GET",
      url: `api/devices/${uid}/ai-series/`,
      params: { start_datetime: statDate, end_datetime: endDate, ...(region ? { region } : {}) },
    });
    if (status === 200) {
      return data;
    }
  } catch (error) {
    console.error("getDeviceAiSeries error:", error);
    return false;
  }
};

// Multi-day range (max 20 days): sparse hourly rows [time, region, class, count]
// from which the dashboard builds the graph, the per-line totals and the
// pedestrian series, so changing line needs no new request.
export const getDeviceAiRange = async ({ startDate, endDate, uid }: any) => {
  try {
    if (!uid) return false;
    const { data, status } = await networkService.request({
      method: "GET",
      url: `api/devices/${uid}/ai-range/`,
      params: { start_date: startDate, end_date: endDate },
    });
    if (status === 200) {
      return data;
    }
  } catch (error) {
    console.error("getDeviceAiRange error:", error);
    return false;
  }
};

export const getDeviceSnapshotsRange = async ({ startDate, endDate, uid }: any) => {
  try {
    if (!uid) return false;
    const { data, status } = await networkService.request({
      method: "GET",
      url: `api/devices/${uid}/snapshots-range/`,
      params: { start_date: startDate, end_date: endDate },
    });
    if (status === 200) {
      return data;
    }
  } catch (error) {
    console.error("getDeviceSnapshotsRange error:", error);
    return false;
  }
};

export const getDeviceWiseAnalatics = async ({ statDate, endDate, zone, activeCarDetails }: any) => {
  try {
    const { data, status } = await axios.get(`${process.env.REACT_APP_UAT_URL}${routes.services.deviceWiseAnalatics(
      statDate,
      endDate,
      zone,
      activeCarDetails
    )}`);
    if (status === 200) {
      return data;
    }
  } catch (error) {
    console.error("getAllDevicesData error:", error);
    return false;
  }
};

export const getDeviceWiseZoneData = async ({ statDate, endDate, uid }: any) => {
  try {
    const { data, status } = await axios.get(
      `${process.env.REACT_APP_UAT_URL}${routes.services.deviceWiseZone(
        statDate, endDate, uid
      )}`
    );
    if (status === 200) {
      return data;
    }
  } catch (error) {
    console.error("getAllDevicesData error:", error);
    return false;
  }
};

export const getPedZoneData = async ({ statDate, endDate, uid }: any) => {
  try {
    const { data, status } = await axios.get(
      `${process.env.REACT_APP_UAT_URL}${routes.services.devicePedZoneData(
        statDate,
        endDate,
        uid
      )}`
    );
    if (status === 200) {
      return data;
    }
  } catch (error) {
    console.error("getPedZoneData error:", error);
    return false;
  }
};

export const getDeviceTtcDataCount = async ({ statDate, endDate, uid }: any) => {
  try {
    const { data, status } = await axios.get(
      `${process.env.REACT_APP_UAT_URL}${routes.services.deviceTtc(
        statDate, endDate, uid
      )}`
    );
    if (status === 200) {
      return data;
    }
  } catch (error) {
    console.error("getAllDevicesData error:", error);
    return false;
  }
};

export const getDevicePetDataCount = async ({ statDate, endDate, uid }: any) => {
  try {
    const { data, status } = await axios.get(
      `${process.env.REACT_APP_UAT_URL}${routes.services.devicePet(
        statDate, endDate, uid
      )}`
    );
    if (status === 200) {
      return data;
    }
  } catch (error) {
    console.error("getAllDevicesData error:", error);
    return false;
  }
};


export const getDeviceWiseZoneDataCount = async ({
  tunnelUrl,
  statDate,
  endDate,
  uid,
}: any) => {
  try {
    const { data, status } = await axios.get(
      `${String(tunnelUrl).replace(/\/+$/, "")}/${routes.services.deviceZoneWiseCount(
        statDate,
        endDate,
        uid
      )}`
    );

    if (status === 200) {
      return data;
    }
    return false;
  } catch (error) {
    console.error("getDeviceWiseZoneDataCount error:", error);
    return false;
  }
};

export const getExportData = async ({ statDate, endDate, deviceId, exportType, tunnelUrl }: any) => {
  try {
    const { data, status } = await networkService.request({
      url: `${routes.services.deviceExportData(statDate, endDate, deviceId)}`,
      method: methods.get,
      responseType: "arraybuffer",
    });
    if (status === 200) {
      return data;
    }
  } catch (error) {
    return false;
  }
};

export const getExportDataTtcPet = async ({
  statDate,
  endDate,
  deviceId,
  exportType,
}: any) => {
  try {
    const { data, status } = await networkService.request({
      url:
        exportType === "PETData"
          ? routes.services.deviceExportDataPet(
            statDate,
            endDate,
            deviceId
          )
          : routes.services.deviceExportDataTtc(
            statDate,
            endDate,
            deviceId
          ),
      method: methods.get,
      responseType: "arraybuffer",
    });
    if (status === 200) {
      return data;
    }
  } catch (error) {
    return false;
  }
};

export const changeStreamType = async ({ ChannelId = 0, SessionId = 92, DataType = 4, deviceID = 0 }) => {
  try {
    const response = await axios.post(
      `http://103.99.38.3:6060/SetConfig/${deviceID}?UserName=admin&SessionId=${SessionId}`,
      `{"ChangeRealStreamType":[{"DataType":${DataType},"ChannelId":${ChannelId}}]}`,
    );
    console.log("response", response);
  } catch (error: any) {
    console.log("error", error?.response?.data);
  }
}

export const getLineDetails = async (tunnelUrl: any) => {
  try {
    const { data, status } = await networkService.request({
      url: `${String(tunnelUrl).replace(/\/+$/, '')}/get-lines`,
      method: methods.get,
    });
    if (status === 200) {
      return data;
    }
  } catch (error) {
    return false;
  }
};

export const getDeviceWiseGraphData = async ({ tunnelUrl, id }: any) => {
  try {
    const { data, status } = await networkService.request({
      url: `${String(tunnelUrl).replace(/\/+$/, "")}/store-watch`,
      method: methods.get,
    });
    if (status === 200) {
      return data;
    }
  } catch (error) {
    return false;
  }
}

export const getDeviceTTCData = async (uuid: any, date: any) => {
  try {
    const { data, status } = await networkService.request({
      url: `${routes.services.ttcData(uuid, date)}`,
      method: methods.get,
    });
    if (status === 200) {
      return data;
    }
  } catch (error) {
    return false;
  }
};

export const getDevicePETData = async (uuid: any, date: any) => {
  try {
    const { data, status } = await networkService.request({
      url: `${routes.services.petData(uuid, date)}`,
      method: methods.get,
    });
    if (status === 200) {
      return data;
    }
  } catch (error) {
    return false;
  }
};

export const getDeviceTtcPetLine = async (tunnelUrl: any) => {
  try {
    const { data, status } = await networkService.request({
      url: `${String(tunnelUrl).replace(/\/+$/, "")}/${routes.services.ttcPetLine}`,
      method: methods.get,
    });
    if (status === 200) {
      return data;
    }
  } catch (error) {
    return false;
  }
};

export const autoDeleteVideoData = async (id: any, days: any) => {
  const payLoadData = {
    "recording_settings": {
      "quality": "high"
    },
    "frame_rate": 25,
    "retention_days": days
  }
  try {
    const { status, data } = await networkService.request({
      method: methods.post,
      url: routes.services.autoDelete(id),
      data: payLoadData,
    });
    if (status === 200) {
      return { data, status };
    }
  } catch (error) {
    return false;
  }
};

export const getDeviceConfigDetails = async (id: any) => {
  try {
    const { data, status } = await networkService.request({
      url: `${routes.services.getDeviceDetailsById(id)}`,
      method: methods.get,
    });
    if (status === 200) {
      return data;
    }
  } catch (error) {
    return false;
  }
};

export const getDeviceImage = async (payload: any) => {
  const payLoadData = {
    paths: payload.map((item: any) => item.path),
  };
  try {
    const { data, status } = await networkService.request({
      url: `${routes.services.getDeviceImage}`,
      method: methods.post,
      data: payLoadData,
    });
    if (status === 200) {
      return data;
    }
  } catch (error) {
    return false;
  }
};

export const getDeviceUploadImage = async (files: File[]) => {
  const formData = new FormData();
  files.forEach((file) => {
    formData.append("images", file);
  });
  try {
    const { data, status } = await networkService.request({
      url: routes.services.getDeviceUploadImage,
      method: "post",
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    if (status === 200) {
      return data;
    }
  } catch (error: any) {
    console.error("UPLOAD ERROR:", error?.response || error);
    return false;
  }
};

export const updateDevicesList = async (
  id: any,
  formValues: any,
  uploadedImages: any[],
  deviceConfigDetails: any
) => {

  const [lat, lng] = formValues.location.split(",");

  const payLoadData = {
    ...deviceConfigDetails,
    device_name: formValues.name,
    lastlocation: {
      lat: Number(lat),
      lng: Number(lng),
    },

    metadata: {
      ...(deviceConfigDetails?.metadata || {}),
      installation: {
        Installation_type: formValues.installation,
        Installation_images: uploadedImages,
      },
    },
  };

  try {
    const { status, data } = await networkService.request({
      method: methods.patch,
      url: routes.services.updateDeviceData(id),
      data: payLoadData,
    });

    if (status === 200) {
      return { data, status };
    }
  } catch (error) {
    return false;
  }
};

export const getLineDataDeviceWise = async ({ dateSelect, tunnelUrl }: any) => {
  try {
    const { data, status } = await axios.get(routes.services.getLineDataDayWise(dateSelect, tunnelUrl));
    if (status === 200) {
      return data;
    }
  } catch (error: any) {
    console.log("error", error?.response?.data);
    return false;
  }
}

export const getUserListFromAdmin = async (payload?: any) => {
  try {
    const { status, data } = await networkService.request({
      method: methods.get,
      url: routes.services.getUserList,
      data: payload,
    });
    if (status === 200) {
      return data;
    }
  } catch (error) {
    return false;
  }
};

export const createUserFromAdmin = async (payload: any) => {
  try {
    const { status, data } = await networkService.request({
      method: methods.post,
      url: routes.services.createUser,
      data: payload,
    });
    if (status === 201) {
      showToast("User Created Successfully", "s");
      return data;
    }
  } catch (error: any) {
    showToast(error?.response?.data?.email[0], "e");
    return false;
  }
};

export const deleteUserFromAdmin = async (id: any) => {
  try {
    const { status, data } = await networkService.request({
      method: methods.delete,
      url: routes.services.deleteUser(id),
      data: id,
    });
    if (status === 200) {
      showToast("User Deleted Successfully", "s");
      return data;
    }
  } catch (error) {
    return false;
  }
};

export const updateUserFromAdmin = async (id: any, payload: any) => {
  try {
    const { status, data } = await networkService.request({
      method: methods.put,
      url: routes.services.updateUser(id),
      data: payload,
    });
    if (status === 200) {
      showToast("User Updated Successfully", "s");
      return data;
    }
  } catch (error) {
    return false;
  }
};